// Copyright (c) 2019 Verimatrix, Inc.  All Rights Reserved.

import React, {Component} from 'react'

import MenuItem from '..'

import AnalyticsLanding from './AnalyticsLanding'

class Analytics extends Component {

  render () {
    return (
      <MenuItem
        title='Product Details'
      >
        <div className='analytics'>
          <AnalyticsLanding/>
        </div>
      </MenuItem>
    )
  }
}

export default (Analytics)
